import type { EphemerisEntry, HourRow } from "../../components/types.js"
import {
  angularSeparationDeg,
  degreesToDms,
  degreesToHms,
  raDecToAltAzDeg,
} from "../simbad.js"
import { parseHorizonsTimeUtc } from "../timezones.js"

export function buildFixedTargetRows(input: {
  targetRaDeg: number
  targetDecDeg: number
  targetName: string
  observer: { lat: number; lon: number }
  moonEntries: EphemerisEntry[]
}): HourRow[] {
  const raStr = degreesToHms(input.targetRaDeg)
  const decStr = degreesToDms(input.targetDecDeg)

  return input.moonEntries
    .map(moonEntry => {
      const dt = parseHorizonsTimeUtc(moonEntry.time)
      if (!dt) return null

      const altAz = raDecToAltAzDeg({
        raDeg: input.targetRaDeg,
        decDeg: input.targetDecDeg,
        latDeg: input.observer.lat,
        lonDeg: input.observer.lon,
        dateUtc: dt,
      })

      const sep = angularSeparationDeg(
        input.targetRaDeg,
        input.targetDecDeg,
        moonEntry.raDeg,
        moonEntry.decDeg
      )

      const entry: EphemerisEntry = {
        time: moonEntry.time,
        ra: raStr,
        dec: decStr,
        raDeg: input.targetRaDeg,
        decDeg: input.targetDecDeg,
        azi: altAz.azDeg,
        elev: altAz.altDeg,
        moonSeparation: sep,
        moonIllumination: moonEntry.moonIllumination,
        twilight: moonEntry.twilight,
        moonPresent: moonEntry.moonPresent,
      }

      return { time: entry.time, target: entry }
    })
    .filter((r): r is HourRow => !!r)
}


